module.exports = __webpack_public_path__ + "img/1560886504.b497e1db.jpg";